<script>
import NegotiationsItem from "@/components/clientNegotiations/NegotiationsItem";
import AgreementContent from "@/components/clientNegotiations/AgreementContent";
import Multiselect from "vue-multiselect";
import {cloneDeep} from "lodash";
import axios from "axios";
import BoardColumn from "./dummy/BoardColumn";

export default {
  page: {
    title: "Offers Board"
  },

  components: {
    NegotiationsItem,
    AgreementContent,
    Multiselect,
    BoardColumn
  },

  data() {
    return {
      title: "Offers Board",
      campaignAgreements: [],

      offers: [],
      negotiations: [],
      done: [],
      showModal: false,
      modalAgreement: {},

      availableCampaigns: {},
      availableCompanies: {},
      filters: {},
    };
  },
  computed: {
    clientId() {
      return this.$route.params.clientId;
    }
  },
  async created() {
    this.$store.commit('loader/START_LOADING');
    try {
      const {data} = await axios.get(`/admin/client/${this.clientId}/campaign-agreement`);
      this.campaignAgreements = data;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error(e)
    } finally {
      this.$store.commit('loader/END_LOADING');
    }

    this.mapArrays();
  },
  methods: {
    mapArrays() {
      Object.keys(this.campaignAgreements).forEach(key => {
        // eslint-disable-next-line no-unused-vars
        for (let [_, campaignAgreement] of Object.entries(this.campaignAgreements[key])) {
          this.availableCampaigns[campaignAgreement.campaign_id] = {
            'campaign_id': campaignAgreement.campaign_id,
            'campaign_name': campaignAgreement.campaign_name,
          }
          this.availableCompanies[campaignAgreement.picture_alt] = {
            'picture_alt': campaignAgreement.picture_alt,
            'picture_url': campaignAgreement.picture_url,
          }
        }

        if (key === 'offer') {
          this.offers = cloneDeep(this.campaignAgreements[key]);
        } else if (['interested', 'pending'].includes(key)) {
          this.negotiations.push(...cloneDeep(this.campaignAgreements[key]));
        } else if (['canceled', 'expired', 'signed', 'aborted'].includes(key)) {
          this.done.push(...cloneDeep(this.campaignAgreements[key]));
        }
        this.offers = this.offers.sort((a, b) => new Date(b.pool_entered) - new Date(a.pool_entered));
        this.negotiations = this.negotiations.sort((a, b) => new Date(b.pool_entered) - new Date(a.pool_entered));
        this.done = this.done.sort((a, b) => new Date(b.pool_entered) - new Date(a.pool_entered));
      });
    },
    async openModal(agreementId) {
      this.$store.commit('loader/START_LOADING');
      try {
        const {data} = await axios.get(`/admin/client/${this.clientId}/campaign-agreement/${agreementId}`);
        this.modalAgreement = data;
        this.showModal = true;
      } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e)
      } finally {
        this.$store.commit('loader/END_LOADING');
      }
    },
    closeModal() {
      this.clearAgreement();
    },
    clearAgreement() {
      this.modalAgreement = {};
      this.showModal = false;
    },
    filterCampaignAgreements(campaignAgreements) {
      return campaignAgreements.filter(campaignAgreement => {
        let show = true;
        if (this.filters.campaign && campaignAgreement.campaign_id !== this.filters.campaign) {
          show = false;
        }
        if (this.filters.companies && this.filters.companies.length > 0 && !this.filters.companies.includes(campaignAgreement.picture_alt)) {
          show = false;
        }

        return show;
      })
    },
  }
}
</script>

<template>
  <div>
    <div>
      <div class="form-group row">
        <div class="col-md-4">
          <div class="page-title-box d-flex align-items-center justify-content-between">
            <h4 class="mb-0 font-size-18">{{ title }}</h4>
          </div>
        </div>
        <div class="col-md-1 d-flex align-items-center justify-content-end">
          <span class="d-none d-md-block font-size-16 " style="margin-right: -15px">
            <i class="fas fa-filter"></i>
          </span>
        </div>
        <div class="col-md-3 mb-2 mb-md-0">
          <multiselect selectLabel="" placeholder="Campaign" selectedLabel="" v-model="filters.campaign" :custom-label="index => availableCampaigns[index].campaign_name" :options="Object.keys(availableCampaigns)" :multiple="false">
            <template slot="option" slot-scope="{ option }" v-if="availableCampaigns[option]">
              <span class="option__desc pl-2">
                <span class="option__title">{{ availableCampaigns[option].campaign_name }}</span>
              </span>
            </template>
          </multiselect>
        </div>
        <div class="col-md-4">
          <multiselect selectLabel="" placeholder="Influencers" selectedLabel="" v-model="filters.companies" :custom-label="index => availableCompanies[index].picture_alt" :options="Object.keys(availableCompanies)" :multiple="true">
            <template slot="option" slot-scope="{ option }" v-if="availableCompanies[option]">
              <img :src="`${availableCompanies[option].picture_url}`" alt
                   class="option__image img-fluid mx-auto " style="border-radius: 50%; width: 30px"/>
              <span class="option__desc pl-2">
                    <span class="option__title">{{ availableCompanies[option].picture_alt }}</span>
                  </span>
            </template>
          </multiselect>
        </div>
      </div>
    </div>

    <div class="drag-container">
      <div class="row drag-list">

        <!--Offers-->
        <BoardColumn heading="Offers" class="col-lg-4">
          <transition-group tag="div" class="pool-card-body" name="list">
            <NegotiationsItem v-for="item in filterCampaignAgreements(offers)" :key="item._id" @click="openModal" :item="item"
                              pool-name="offer" :class="['list-item']"/>
          </transition-group>
        </BoardColumn>

        <!--Negotiations-->
        <BoardColumn heading="Negotiations" class="col-lg-4">
          <transition-group tag="div" class="pool-card-body" name="list">
            <NegotiationsItem v-for="item in filterCampaignAgreements(negotiations)" :key="item._id" @click="openModal" :item="item"
                              pool-name="negotiations" :class="['list-item']"/>
          </transition-group>
        </BoardColumn>

        <!--Done-->
        <BoardColumn heading="Done" class="col-lg-4">
          <transition-group tag="div" class="pool-card-body" name="list">
            <NegotiationsItem v-for="item in filterCampaignAgreements(done)" :key="item._id" @click="openModal" :item="item"
                              pool-name="negotiations" :class="['list-item']"/>
          </transition-group>
        </BoardColumn>

      </div>
      <b-modal body-class="p-0" content-class="border-0" @hidden="closeModal" v-model="showModal" size="lg" centered
               hide-footer hide-header>
        <AgreementContent :agreement="modalAgreement" @closeModal="showModal = false"/>
      </b-modal>
    </div>
  </div>
</template>

<style scoped>

.list-item {
  transition: opacity 0.6s, transform 0.6s;
}

.list-enter, .list-leave-to
  /* .list-complete-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(-30px);
}

.list-leave-active {
  position: absolute;
  width: calc(100% - 40px);
  opacity: 0;
}

</style>
